import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import {
  useAppEventLeaderBoardSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY } from "src/_config";
import ProgressBar from "src/components/common/ProgressBar";
import Sponsor from "src/components/common/Sponsor";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventLeaderBoardPage() {
  const eventApi = useEventApi();
  const leaderBoardSelector = useAppEventLeaderBoardSelector() as {
    rodeo_event_game_info?: { show_leaderboard?: number };
    performance_dtls?: { title?: string };
    rodeo_event_dtls?: { title?: string };
    users?: { data?: Array<{ id?: number; user_id?: number; display_name?: string; first_name?: string; last_name?: string; percentage?: number }> };
  } | null;
  const history = useHistory();
  const { eventId, performanceId } = useParams<{ eventId?: string; performanceId?: string }>();
  const e_id: number = parseInt(cryptr.decrypt(eventId || ''));
  // const p_id: number = parseInt(cryptr.decrypt(performanceId));
  const userDetails = useAppUserDetailsSelector();
  const [leaderboardType, setLeaderboardType] = useState<number>(0);
  const [leaderboardList, setLeaderboardList] = useState<Array<{ id?: number; user_id?: number; display_name?: string; first_name?: string; last_name?: string; percentage?: number }> | undefined>(undefined);
  const [progressPercent, setProgressPercent] = useState<number>(0);

  const goBack = (e?: React.MouseEvent<HTMLAnchorElement>) => {
    if (e) {
      e.preventDefault();
    }
    // history.push(`/event/${eventId}`)
    history.goBack();
  };

  const callViewLeaderBoard = (locId?: string | number) => {
    const params: Record<string, unknown> = {
      rodeo_event_id: e_id,
    };
    if (performanceId) {
      params["performance_id"] = parseInt(cryptr.decrypt(performanceId));
    }
    if (locId) {
      params["location_id"] = locId;
    }
    eventApi.callViewLeaderBoard(
      params as Record<string, unknown>,
      (_message: string, resp: unknown) => {
        if (resp) {
          // Handle response
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (userDetails) {
      // getLeaderboardLocationList();
    }
  }, [userDetails]);

  useEffect(() => {
    callViewLeaderBoard();
  }, []);

  useEffect(() => {
    const x = leaderBoardSelector?.rodeo_event_game_info?.show_leaderboard;
    console.log({ leaderBoardSelector, x });
    if (x !== undefined) {
      setLeaderboardType(x);
      if (leaderBoardSelector?.users?.data) {
        setLeaderboardList(leaderBoardSelector.users.data);
      }
      // setProgressPercent(p);
      // if (x == 1) {
      //   setLeaderboardList(leaderBoardSelector?.players);
      // } else if (x == 2) {
      //   setLeaderboardList(leaderBoardSelector?.riders);
      // } else {
      //   setLeaderboardList(leaderBoardSelector?.events);
      // }
    }
  }, [leaderBoardSelector]);

  useEffect(() => {
    if (userDetails && leaderboardList && Array.isArray(leaderboardList)) {
      const p = leaderboardList.find((x) => x.user_id == (userDetails as { id?: number })?.id)?.percentage;
      if (p !== undefined) {
        setProgressPercent(p);
      }
    }
  }, [userDetails, leaderboardList]);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <Link to="#" onClick={(e) => goBack(e)} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </Link>
        {leaderBoardSelector?.performance_dtls?.title || "Overall"}
      </h2>
      {progressPercent > 0 && <ProgressBar progressPercent={progressPercent} />}
      <div className="text-center text-white py-3">{leaderBoardSelector?.rodeo_event_dtls?.title}</div>
      {/* {userDetails && leaderBoardSelector?.rodeo_event_dtls?.is_assign_geo_location == "1" && (
        <SelectInput
          onChange={handleListChange}
          value={undefined}
          defaultValue={{ label: "Overall", value: "0" }}
          options={listOptions}
          // error={errors.country}
          placeholder="Select"
        />
      )} */}
      <div className="score-range-wrap">
        <div className="score-box d-flex justify-content-between">
          {/* <h4 className="d-inline-block title-player">{leaderboardType==3 ? "Events" : "Riders"}</h4> */}
          <h4 className="d-inline-block title-player">
            {leaderboardType == 3 ? "Events" : leaderboardType == 1 ? "User" : "Riders"}
          </h4>
          <div className="gua-sc">{leaderboardType == 2 ? "Vote Received(%)" : "Progress(%)"}</div>
        </div>
        <ul className="cons-list">
          {leaderboardList && Array.isArray(leaderboardList) && leaderboardList.length ? (
            leaderboardList.map((item) => (
              <li key={item.id}>
                <span className="name-img">
                  {/* <em className="user-img-wrap">
                    <img
                      src={
                        leaderboardType == 2 && item?.rider?.id != 0
                          ? item?.rider?.thumb
                          : leaderboardType == 2 && item?.contestant_dtls?.avatar?.id != 0
                          ? item?.contestant_dtls?.avatar?.thumb
                          : leaderboardType == 1 && item?.user_details?.avatar?.thumb
                          ? item?.user_details?.avatar?.thumb
                          : leaderboardType == 3
                          ? item?.details?.event_truck?.id != 0
                            ? item?.details?.event_truck?.thumb
                            : item?.details?.rodeo_pick_event?.avatar?.thumb
                          : "/images/no-image.png"
                      }
                      alt={item.name}
                    />
                  </em> */}
                  {/* {leaderboardType == 2
                    ? item?.name
                    : leaderboardType == 1
                    ? item?.user_details?.display_name || item?.user_details?.full_name
                    : leaderboardType == 3
                    ? item?.event_name || item?.details?.rodeo_pick_event?.title
                    : ""} */}
                  {item?.display_name || item?.first_name + " " + item?.last_name}
                </span>
                <span className="count-vote">
                  {/* {userDetails &&
                  eventGameListSelector?.filter((x: any) => x.ispicked).length > 0 &&
                  leaderboardType == 2 &&
                  item.vote
                    ? removeTrailingZero(item.vote)
                    : leaderboardType == 1 && item?.total_win
                    ? item?.total_win + "/" + leaderBoardSelector?.events_count
                    : leaderboardType == 3 && item?.total_win
                    ? item?.total_win
                    : "-"} */}
                  {item?.percentage || "-"}
                </span>
              </li>
            ))
          ) : (
            <li className="no-rider">No record found!</li>
          )}
        </ul>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
